/**
 * Global thumbnail component for displaying image attachments.
 *
 * @param {{ url: string, caption?: string }[]} images - Array of image objects. Shows placeholder when empty.
 * @param {(images: { url: string, caption?: string }[]) => void} [onOpenPreview] - Called when thumbnail is clicked.
 */

import { Box, Image } from '@chakra-ui/react';

import ImagePlaceholder from 'Asset/image/image-placeholder.svg';
import { TextBold } from 'UiKit/typography';
import { Condition } from 'Component/others';

import styles from './styles.module.css';

const AttachmentImage = ({ images, onOpenPreview }) => {
  const validImages = images?.filter((img) => img.url != null) ?? [];
  const hasImages = validImages.length > 0;
  const image = hasImages ? validImages[0].url : ImagePlaceholder;

  const handleThumbnailClick = () => {
    if (hasImages && onOpenPreview) {
      onOpenPreview(validImages);
    }
  };

  return (
    <Box className={styles['thumbnail-wrapper']} onClick={handleThumbnailClick}>
      <Image
        src={image}
        alt="attachment"
        className={styles['thumbnail-image']}
        objectFit="cover"
        onError={(e) => {
          e.target.src = ImagePlaceholder;
        }}
      />
      <Condition statement={validImages.length > 1}>
        <Box className={styles['counter-overlay']}>
          <TextBold fontSize="xs" color="white">
            {validImages.length - 1}+
          </TextBold>
        </Box>
      </Condition>
    </Box>
  );
};

export default AttachmentImage;
